import { render, staticRenderFns } from "./TopicDrawer.vue?vue&type=template&id=c94942be&scoped=true"
import script from "./TopicDrawer.vue?vue&type=script&lang=js"
export * from "./TopicDrawer.vue?vue&type=script&lang=js"
import style0 from "./TopicDrawer.vue?vue&type=style&index=0&id=c94942be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94942be",
  null
  
)

export default component.exports